import styled from 'styled-components';

export default styled.label`
  margin-bottom: 0;
`;
